import React, { useEffect, useState, Key } from 'react';
import DynamicTable from '../../../components/CommonTable/DynamicTable';
import { ErrorMessages, debounce, useGetApiRequests, useSelector } from '../../../common/CommonExport';
import UserHeader from '../layout/UserHeader';
import { Modal, Pagination, Tooltip } from 'antd';
import CreateEditUser from '../CreateEditUser/CreateEditUser';
import DeleteConfirmationModal from '../../Organization/DeleteConfirmationModal';
import { handleDeleteDesignation } from '../../Organization/OrganisationHelper';
import PopupModal from '../../employee/employee-details/employee-profile/modal/PopupModal';
import { UserData, UserParams, UserApiResponseItem, UserApiResponse } from './UsersTypes';
import { OrganisationIdState } from '../../../common/types';

const Designations = () => {
    const userList = useGetApiRequests('user', 'GET');
    const orgId = useSelector((state: OrganisationIdState) => state?.organisationId?.id);
    const deleteSingleUserApi = useGetApiRequests('singleUserDelete', 'DELETE')
    const [selectedRows, setSelectedRows] = useState<UserData[] | Key[]>([]);
    const [elementData, setElementData] = useState<UserData[]>([]);
    const [loader, setLoader] = useState(false);
    const [open, setOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false)
    const [deleteMessage, setDeleteMessage] = useState('');
    const [isSingleDelete, setIsSingleDelete] = useState(false);
    const [deletePopUp, setDeletePopUp] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [editRecord, setEditRecord] = useState<UserData>();
    const [count, setCount] = useState<number>();
    const [modalerrMessage, setModalErrMessage] = useState('')
    const [popModal, setPopModal] = useState(false)
    const [modalResponse, setModalResponse] = useState('')
    const [modalButtonShow, setmodalButtonShow] = useState(true)
    const onShowSizeChange = (current: number, newSize: number) => {
        setPageSize(newSize);
        setCurrentPage(1);
    };
    const onSearch = debounce((searchTerm: string) => {
        getUsersList(searchTerm);
    }, 500);
    useEffect(() => {
        const tags: HTMLCollectionOf<Element> = document.getElementsByClassName('ant-table-content');
        if (tags[1]) {
            (tags[1] as HTMLElement).scrollTop = 0;
        }
        getUsersList();
    }, [currentPage, pageSize]);
    const getUsersList = (searchTerm = '') => {
        setLoader(true);
        const start: number = (currentPage - 1 === 0) ? 0 : currentPage - 1;
        const param: UserParams = {
            start: start,
            limit: pageSize,
            organisationId: orgId,
            isActive: true
        }
        if (searchTerm !== '') {
            param.search = searchTerm
        }
        userList("", param)
            .then((response) => {
                const res = response as UserApiResponse;
                const data: UserApiResponseItem[] = res?.data?.data;
                if (data) {
                    const tempUserList: UserData[] = data.map((item: UserApiResponseItem) => {
                        let obj = {
                            Role: item?.role?.name,
                            Email: item.email,
                            Name: item.name,
                            key: item.userId,
                            roleId: item?.role?.roleId
                        };
                        return obj;
                    });
                    setCount(res?.data?.totalResults)
                    setTimeout(() => {
                        setLoader(false)
                    }, 1000)
                    setElementData(tempUserList)
                }
            })
            .catch((err: unknown) => {
                setPopModal(true)
                setmodalButtonShow(false)
                setModalErrMessage(ErrorMessages.somethingWentWrong)
                setModalResponse('error')
                setTimeout(() => {
                    handleClosePopUpModal()
                    setLoader(false);
                }, 1500)
            });

    }
    const columns = [
        {
            title: 'User Name',
            dataIndex: 'Name',
            key: 'Name',
        },
        {
            title: 'Role',
            dataIndex: 'Role',
            key: 'Role',
        },
        {
            title: 'Email',
            dataIndex: 'Email',
            key: 'Email',
        },

        {
            title: <div className='text-center pr-[14px]'>Action</div>,
            dataIndex: 'deleteButton, editButton',
            align: 'center',
            render: (_: unknown, record: UserData) => (
                <div className='flex justify-center gap-3'>
                    <Tooltip placement="top" title="Edit">
                        <span className="material-symbols-outlined cursor-pointer hover:text-primary" onClick={() => handleEditRow(record)} >
                            edit
                        </span>
                    </Tooltip>
                    <Tooltip placement="top" title="Delete">
                        <span className="material-symbols-outlined cursor-pointer hover:text-primary" onClick={() => handleSingleDelete(record)}>
                            delete
                        </span>

                    </Tooltip>
                </div>
            ),
        }
    ];

    const handleOpenModal = () => {
        setIsEdit(false)
        setOpen(true)
    };
    const handleCloseModal = () => {
        setOpen(false)
    };
    const handleEditRow = (record: UserData) => {

        setIsEdit(true)
        setOpen(true)
        setEditRecord(record);
    };
    const handleSelectedRows = (selected: Key[]) => {
        setSelectedRows(selected);
        setIsSingleDelete(false);
        setDeleteMessage(`Are you sure you want to delete these (${selected.length}) users?`);
    }
    const handleSingleDelete = (record: UserData) => {
        setDeletePopUp(true);
        setIsSingleDelete(true);
        const recordArray: UserData[] = [];
        recordArray.push(record);
        setSelectedRows(recordArray);
        setDeleteMessage(`Are you sure you want to delete (${record?.Name})?`);
    };
    const handleSingleSelectDelete = async () => {
        const deleteArray: { userId: Key }[] = [];
        setDeletePopUp(false);
        const roleId = { 'userId': (selectedRows[0] as UserData).key };
        deleteArray.push(roleId);
        handleDeleteDesignation(deleteSingleUserApi, deleteArray, getUsersList, '');
        setSelectedRows([])

    };
    const handleDeleteSelected = async () => {
        const deleteArray: { userId: Key }[] = [];
        selectedRows.forEach((item: Key | UserData) => {
            const id = {
                'userId': item as Key
            }
            deleteArray.push(id);
        })
        handleDeleteDesignation(deleteSingleUserApi, deleteArray, getUsersList, '');
        setSelectedRows([])
    };
    const handleCloseDelete = () => setDeletePopUp(false);
    const handleClosePopUpModal = () => {
        setPopModal(false)
        handleCloseModal()
    }

    return (

        <div className="user-table">
            <UserHeader types={"Users"} handleOpenModal={handleOpenModal} onSearch={onSearch} setDeletePopUp={setDeletePopUp} selectedRows={selectedRows} isSingleDelete={isSingleDelete} />
            <DynamicTable columns={columns} data={elementData} handleSelectedRows={handleSelectedRows} loading={loader} />
            <div className='pagination'>
                <Pagination
                    className='float-right flex flex-row p-6'
                    showSizeChanger
                    onShowSizeChange={onShowSizeChange}
                    current={currentPage}
                    total={count}
                    pageSize={pageSize}
                    onChange={(page) => setCurrentPage(page)}
                />
            </div>
            {open && (
                <Modal centered open={open} onCancel={handleCloseModal} className='modal-user' title={isEdit ? "Edit User" : "Create user"} footer={null} maskClosable={false}>
                    <CreateEditUser isEdit={isEdit} getUsersList={getUsersList} setOpen={setOpen} selectedRecord={editRecord} />
                </Modal>
            )}

            {deletePopUp && <DeleteConfirmationModal open={deletePopUp} handleSingleSelectDelete={handleSingleSelectDelete} handleDeleteSelected={handleDeleteSelected} handleCloseDelete={handleCloseDelete} selectedRows={selectedRows} type='designation' isSingleDelete={isSingleDelete} deleteMessage={deleteMessage} />}
            {popModal && <PopupModal message={modalerrMessage} open={popModal} handleModalClose={handleClosePopUpModal} response={modalResponse} modalButtonShow={modalButtonShow} />}
        </div>

    );
};

export default Designations;